import { useEffect } from "react";

import { useSnackbar } from "notistack";

import { trpc } from "../../../common/helpers/trpc";

import { PDFContentViewer } from "./PDFContentViewer";
import { PDFPreview } from "./PDFPreview";

import { useBreakpointLogger } from "@/common/hooks/useBreakpointLogger";
import { useTranslate } from "@/common/hooks/useTranslate";
import { GetPreviewETicketInHTMLInput } from "@/common/types/trpc";

interface ETicketPDFPreviewProps {
  handleIframeLoad?: () => void;
  getPreviewETicketInHtmlInput: GetPreviewETicketInHTMLInput;
  iframeRef?: React.RefObject<HTMLIFrameElement | null>;
  width?: number;
  height?: number;
}

export const ETicketPDFPreview = ({
  getPreviewETicketInHtmlInput,
  handleIframeLoad,
  iframeRef,
  width = 1275,
  height = 1650,
}: ETicketPDFPreviewProps) => {
  const breakpoint = useBreakpointLogger();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslate();
  const { data, isLoading, isError } = trpc.getPreviewETicketInHTML.useQuery(getPreviewETicketInHtmlInput);

  useEffect(() => {
    if (isError) {
      enqueueSnackbar(t("common", "unknownError", { code: 119 }), { vibe: "danger" });
    }
  }, [isError, enqueueSnackbar, t]);

  const eTicketHtml = data;
  if (!eTicketHtml) {
    return null;
  }

  return (
    <PDFPreview
      iframeRef={iframeRef}
      onLoad={handleIframeLoad}
      dataTest="preview-e-ticket-iframe"
      title="E-ticket Preview"
    >
      <PDFContentViewer
        html={eTicketHtml}
        breakpoint={breakpoint}
        isSkeleton={isLoading}
        rounded
        scaleSettings={{
          xl: 0.5,
          lg: 0.4,
          md: 0.33,
          xs: 0.29,
        }}
        width={width}
        height={height}
      />
    </PDFPreview>
  );
};
